module.exports = __webpack_public_path__ + "assets/images/background@2x.f76337c0999a6b75aeb10b0e4245f293.webp";